export const API_ENDPOINTS = {
  INSTRUMENTS: '/instruments',
  INSTRUMENTS_REFRESH_PRICES: '/instruments/refresh-prices',
  TRANSACTIONS: '/transactions',
  TRANSACTIONS_PLATFORMS: '/transactions/platforms',
  PORTFOLIO_SUMMARY_HISTORICAL: '/portfolio-summary/historical',
  PORTFOLIO_SUMMARY_CURRENT: '/portfolio-summary/current',
  PORTFOLIO_SUMMARY_SERIES: '/portfolio-summary/series',
  PORTFOLIO_SUMMARY_INTRADAY: '/portfolio-summary/intraday',
  PORTFOLIO_SUMMARY_BENCHMARK: '/portfolio-summary/benchmark',
  PORTFOLIO_SUMMARY_RANGE_CHANGE: '/portfolio-summary/range-change',
  PORTFOLIO_SUMMARY_RECALCULATE: '/portfolio-summary/recalculate',
  PORTFOLIO_SUMMARY_XIRR_WINDOWS: '/portfolio-summary/xirr-windows',
  PORTFOLIO_SUMMARY_ANNUAL_WINDOWS: '/portfolio-summary/annual-windows',
  ETF_BREAKDOWN: '/etf-breakdown',
  FUNDS: '/funds',
  DIVERSIFICATION: '/diversification',
  ENUMS: '/enums',
  LOGOS: '/logos',
  CALCULATOR: '/calculator',
  BUILD_INFO: '/build-info',
  MONITORING_COLLECTIONS: '/monitoring/collections',
  LIVE_UPDATES: '/live-updates',
  RADIO: '/radio',
} as const

export const REFETCH_INTERVALS = {
  DIVERSIFICATION_ETFS: 60 * 60 * 1000,
  PLATFORMS: 60 * 60 * 1000,
  DAILY_CALENDAR: 5 * 60 * 1000,
} as const
